import React, { Component } from "react";
import { getSkipOptions } from "../../../../services/formService";
import { stripTags } from "../../../common/commonFuncs";
import Select from "react-select";

class SkipLogic extends Component {
  Options = [];
  state = {
    Widget_ID: this.props.Widget_ID,
    Question_Answers: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    let { data: Options } = await getSkipOptions(this.state.Widget_ID);
    this.Options = Options.map(function (option) {
      return {
        label: stripTags(option.Question_Text),
        value: option.Widget_ID,
      };
    });
    this.setState({ Question_Answers: this.props.Answers });

    this.setState({ loading: false });
  }

  handleSelection = (idx, selected) => {
    let Question_Answers = [...this.state.Question_Answers];
    Question_Answers[idx].SkipLogic = Array.isArray(selected)
      ? selected.map((x) => x.value)
      : [];
    this.setState({ Question_Answers });
  };

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;
    let { Question_Answers, Widget_ID } = this.state;
    return (
      <div>
        {Question_Answers.map((ans, idx) => {
          return (
            <div className="form-row" key={Widget_ID + "skip" + idx}>
              <div className="form-group col-md-5 text-center">
                {stripTags(ans.Answer_Text)}
              </div>
              <div className="form-group text-center col-md-1">Skip</div>
              <div className="form-group col-md-6">
                <Select
                  closeMenuOnSelect={false}
                  isMulti
                  value={this.Options.filter((obj) =>
                    ans.SkipLogic.includes(obj.value)
                  )}
                  options={this.Options}
                  onChange={(selection) => this.handleSelection(idx, selection)}
                  classNamePrefix="select"
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkipLogic;
